import React, { useCallback, useState } from 'react';

import { ApiPosition } from '#/api/types';
import TPSLModal from '#/components/positions/takeProfitStopLoss/TPSLModal';
import { useSelector } from '#/reduxState/store';

import { resetCurrentTpSlOrderLine } from './positionTPSLHandle';

export function usePositionTPSLHandlers({
  currentMarketPosition,
}: {
  currentMarketPosition: ApiPosition | undefined | false;
}) {
  const currentMarket = useSelector(state => state.markets.currentMarket);

  /** Open modal to update TP/SL for position rendered on the chart */
  const [editTpSl, setEditTpSl] = useState<
    | {
        proposedPrice: number;
        type: 'takeProfit' | 'stopLoss';
      }
    | undefined
  >();

  const handleEditTpSL = useCallback(
    (price: number, type: 'takeProfit' | 'stopLoss') =>
      setEditTpSl({ proposedPrice: price, type }),
    []
  );

  return {
    handleEditTpSL,
    tpSlModalPlaceholder:
      editTpSl && currentMarket.pair ? (
        <TPSLModal
          onClose={() => {
            setEditTpSl(undefined);
            resetCurrentTpSlOrderLine(currentMarketPosition);
          }}
          market={currentMarket.pair}
          initialStopLossPrice={
            editTpSl.type === 'stopLoss' ? editTpSl.proposedPrice : undefined
          }
          initialTakeProfitPrice={
            editTpSl.type === 'takeProfit' ? editTpSl.proposedPrice : undefined
          }
        />
      ) : null,
  };
}
